import React from "react"
import { cx } from "ramda-extension"
import { Grid } from "@mui/material"
import { makeStyles } from "@mui/styles"

const useStyles = makeStyles({
  itemTitle: {
    marginBottom: "5px",
    marginTop: "18px !important",
  },
  title: {
    "&::first-letter": {
      textTransform: "uppercase",
    },
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "15px",
    marginTop: "25px",
  },
})

interface FilterGroupProps {
  children?: any;
  key?: any;
  className?: any;
  groupTitle?: string;
  xs: any;
}

export const FiltersGroup = ({ children, key, groupTitle, xs }: FilterGroupProps) => {
  const { title, itemTitle } = useStyles()

  return (
    <Grid {...{ key, xs }}>
      {groupTitle ? <div className={cx(title, itemTitle)}>{groupTitle}</div> : null}
      {children}
    </Grid>
  )
}
